import React from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, Building2, Sparkles } from 'lucide-react';
const audiences = [{
  icon: Users,
  title: 'Orientadores en adicciones',
  description: 'Que trabajan cuerpo a cuerpo con personas con ludopatía y necesitan herramientas concretas para cada etapa del proceso.',
  isNew: false
}, {
  icon: Heart,
  title: 'Acompañantes terapéuticos',
  description: 'Que quieren estructurar mejor su práctica sin necesitar un posgrado clínico para hacerlo.',
  isNew: false
}, {
  icon: Building2,
  title: 'Equipos de ONGs y centros de día',
  description: 'Que trabajan con recursos limitados y necesitan material listo para usar desde hoy.',
  isNew: false
}, {
  icon: Sparkles,
  title: 'Orientadores que quieren profesionalizar su práctica',
  description: 'Querés trabajar con más estructura, más claridad y más herramientas sin depender solo de la intuición.',
  isNew: true
}];
export function Audience() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-19">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark mb-3 md:mb-4" data-id="element-20">
            ¿Para quién es?
          </h2>
          <p className="text-base md:text-lg text-gray-700" data-id="element-21">
            Diseñado para vos si acompañás personas con adicciones conductuales
          </p>
        </motion.div>

        <div className="space-y-2 md:space-y-3 mb-6 md:mb-8" data-id="element-22">
          {audiences.map((audience, index) => {
          const Icon = audience.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} whileHover={{
            x: 4
          }} className="group bg-cream-light px-4 md:px-5 py-3 md:py-4 rounded-lg border-l-2 border-gold/40 hover:border-gold hover:shadow-md transition-all flex items-center gap-3 md:gap-4 cursor-default relative" data-id="element-23">
                <div className="flex-shrink-0 w-10 h-10 md:w-11 md:h-11 rounded-full bg-gold/15 group-hover:bg-gold/25 flex items-center justify-center transition-colors" data-id="element-24">
                  <Icon className="w-5 h-5 md:w-5 md:h-5 text-gold" data-id="element-25" />
                </div>
                <div className="flex-1 min-w-0 pr-14 md:pr-16" data-id="element-26">
                  <h3 className="font-semibold text-navy-dark text-sm md:text-base leading-snug" data-id="element-27">
                    {audience.title}
                  </h3>
                  <p className="text-gray-700 text-xs md:text-sm mt-0.5 leading-snug" data-id="element-28">
                    {audience.description}
                  </p>
                </div>
                {audience.isNew && <span className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 bg-gold text-navy-dark text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-29">
                    NUEVO
                  </span>}
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-gray-700 text-sm md:text-base" data-id="element-30">
          ¿No estás seguro si es para vos?{' '}
          <a href="#garantia" className="text-gold font-semibold hover:underline" data-id="element-31">
            Tenés 7 días de garantía →
          </a>
        </motion.p>
      </div>
    </section>;
}